import { EcommerceCartItem } from './types';

export const sumOfItemPrice = (viewedItem: EcommerceCartItem | Array<EcommerceCartItem> | undefined) => {
  return Array.isArray(viewedItem)
    ? viewedItem.reduce((acc, item) => {
        return acc + item?.price || 0;
      }, 0)
    : viewedItem?.price || 0;
};

export const getMarketplaceCartType = (cartItems: Array<EcommerceCartItem | undefined>) => {
  const marketplaceCartTypeSet = new Set();
  cartItems.forEach(item => {
    item.marketplace_product === 'N' ? marketplaceCartTypeSet.add('1P') : marketplaceCartTypeSet.add('3P');
  });

  return Array.from(marketplaceCartTypeSet).sort().join(',');
};
